var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-panel-section',{staticClass:"widget-panel__section",attrs:{"header":_vm.header}},_vm._l((_vm.widgetsList),function(widget,index){return _c('widget-panel-section-item',{key:("wpci-" + index),attrs:{"widget":widget}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }